import { action, atom } from "@reatom/framework";
import { withLocalStorage } from "@reatom/persist-web-storage";

export type OrderViews = "table" | "tile";
export const ordersViewAtom = atom("tile" as OrderViews, "OrderListView").pipe(
  withLocalStorage("orderListView"),
);

export const setOrdersViewAtom = action((ctx) => {
  const currentValue = ctx.get(ordersViewAtom);
  ordersViewAtom(ctx, currentValue == "table" ? "tile" : "table");
});
